import FiltersRoot from "@/components/shared/data-table/filters";
import { GlobalFilterInput } from "@/components/shared/data-table/filters/inputs/global-filter";
import { DatePickerWithRangeInput } from "@/components/shared/form/data-picker-with-range-input";
import { Button } from "@/components/ui/button";
import { useNavigateToInvoiceWithBrowsingQueue } from "@/hooks/useNavigateToInvoiceWithBrowsingQueue";
import type { GetAllInvoiceInvoice } from "@/queries/invoices/get-all";
import type { Table } from "@tanstack/react-table";
import { ArrowRight, CalendarClock } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  showStartReviewButton?: boolean;
  filters: any;
  setFilters: (filters: any) => void;
  globalSearch: string;
  setGlobalSearch: (globalSearch: string) => void;
  table: Table<GetAllInvoiceInvoice>;
};

export const InvoicesFilters = ({
  showStartReviewButton = false,
  filters,
  setFilters,
  globalSearch,
  setGlobalSearch,
  table,
}: Props) => {
  const { t } = useTranslation();
  const navigateToInvoice = useNavigateToInvoiceWithBrowsingQueue(table);

  return (
    <div>
      <div className="flex flex-row gap-4 py-2">
        <div className="w-full flex items-center justify-between">
          <div className="flex flex-row gap-2">
            <div className="w-96">
              <GlobalFilterInput
                placeholder={t("payables.search")}
                value={globalSearch}
                onChange={setGlobalSearch}
              />
            </div>
            <FiltersRoot onSubmit={setFilters} values={filters}>
              <DatePickerWithRangeInput
                name="dueDate"
                placeholder={t("payables.date")}
                Icon={CalendarClock}
              />
            </FiltersRoot>
          </div>
          {showStartReviewButton && (
            <Button
              className="px-4"
              onClick={() =>
                navigateToInvoice(
                  table.getRowModel().rows[0].original.invoice.invoiceId,
                )
              }
              disabled={table.getRowModel().rows.length === 0}
            >
              {t("payables.start_review")}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
